import { useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Backdrop, CircularProgress, LinearProgress } from '@mui/material';

const theme = createTheme({
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          display: 'grid',
          gridAutoFlow: 'row',
          alignContent: 'center',
          justifyItems: 'center',
          gridRowGap: 'var(--spacing-6)',

          '&#backdrop-loading': {
            opacity: '0 !important',
            pointerEvents: 'none',
            zIndex: 7777777,
          },
          '&#backdrop-loading.loading': {
            opacity: '1 !important',
            pointerEvents: 'all',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: 'var(--white)',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          width: '20rem',
          backgroundColor: 'var(--white)',
        },
        bar: {
          backgroundColor: 'var(--primary-100)',
        },
      },
    },
  },
});

let backdropSetProgressBase: any = () => null;

export const backdropSetProgress = (key?: string, value = 0) => {
  if (!key) {
    backdropSetProgressBase([]);
    return;
  }

  backdropSetProgressBase((prev: any[]): any[] => {
    const index = prev.findIndex((item) => item.key === key);
    if (index !== -1) {
      prev[index].value = prev[index]?.value > value ? prev[index]?.value : value;
    } else {
      prev = [...prev, { key, value }];
    }
    return [...prev];
  });
};

export const BackdropLoading = () => {
  const [progress, setProgress] = useState<{ key: string; value: number }[]>([]);
  const [, setUpdateKey] = useState(Math.random());

  useEffect(() => {
    backdropSetProgressBase = (value: any) => {
      setProgress(value);
      setUpdateKey(Math.random());
    };
  }, []);

  useEffect(() => {
    const backdropEl = document.querySelector('#backdrop-loading');
    const isOpen = backdropEl?.className.includes('loading');

    if (!isOpen) return;

    const intervalId = setInterval(() => {
      progress.forEach((item, i) => {
        if (item.value < 90) {
          backdropSetProgress(item.key, Math.min(item.value + 2.5 * (progress.length - i), 90));
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [progress]);

  return (
    <ThemeProvider theme={theme}>
      <Backdrop id={'backdrop-loading'} open={true}>
        <CircularProgress />
        {progress.map((item, index) => (
          <LinearProgress key={index} variant="determinate" value={item.value} />
        ))}
      </Backdrop>
    </ThemeProvider>
  );
};
